import { XColors } from './types';

const white = '#FFFFFF';
const gray100 = '#F5F9FF';
const gray600 = '#6D789F';
const gray300 = '#DDE6F6';
const gray500 = '#A1AACA';
const xSky = '#0A1334';

const colors: XColors = {
  xBlue: {
    main: '#5555EE',
    light: '#7777F1',
    dark: '#3B3BA6',
  },
  xTinny: {
    main: '#E63FFF',
    light: '#EF81FF',
    dark: '#C424DC',
  },
  xOrange: {
    main: '#FF7D00',
    light: '#FF9733',
    dark: '#B25700',
  },
  xSpark:
    'linear-gradient(56.45deg, #FF7D00 1.78%, #FC771C 16.06%, #F56565 51.07%, #EA4AD8 98.59%, #E640FF 104.65%)',
  background: {
    default: gray100,
    gradient: 'radial-gradient(44% 44% at 50% 50%, #E0EDFF 0%, #F0F6FF 100%)',
    paper: white,
  },
  text: {
    primary: xSky,
    secondary: '#4F5A84',
    disabled: '#AAB2CF',
    light: white,
  },
  divider: {
    main: gray300,
    dark: gray500,
  },
  grey: {
    m50: '#FDFEFF',
    m100: gray100,
    m200: '#E6EFFE',
    m300: gray300,
    m400: '#C8D0E5',
    m500: gray500,
    m600: gray600,
    m700: '#4F5A84',
    m800: '#333E67',
    m900: xSky,
  },
  ui: {
    danger: {
      main: '#DD1515',
      dark: '#AD1313',
      light: '#FFE3E3',
    },
    success: {
      main: '#3FA96B',
      dark: '#1C8B48',
      light: '#E1FAED',
    },
    warning: {
      main: '#F4B231',
      dark: '#C3900C',
      light: '#FCF0DB',
    },
    information: {
      main: '#315AFE',
      dark: '#1A38B0',
      light: '#D5DDFC',
    },
  },
};

export default colors;
